import { useState } from 'react'
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import axiosInstance from 'interceptor/axiosInstance';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize, serialize } from 'serializr';
import ProductCreationService from 'services/ProductsService/productCreation.service';
import { LiveStockCommodityModel } from 'models/Farmbox/LiveStock/stage0.model';
import { notificationConstants } from 'constants/FarmboxConstants/stage0.constants';
import { generatePath } from 'react-router-dom';
import { urlToRcFile } from 'shared/utils/convertIntoBlob';

const LiveStockService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [updateLoading, setUpdateLoading] = useState<boolean>(false); // TODO: Will be use setter function while api implementation
    const [commodity, setCommodity] = useState<LiveStockCommodityModel>()
    const { uploadProductImage } = ProductCreationService();

    const createLiveStockCommodity = async (payload: LiveStockCommodityModel) => {
        try {
            setUpdateLoading(true);
            const uploadedImage = payload.image;
            delete payload.image
            const desiredPayload = serialize(LiveStockCommodityModel, payload)
            const response = await axiosInstance.post(ApiRoutes.LIVE_STOCK_COMMODITY, { commodity: desiredPayload })
            Notification({
                message: notificationConstants.SUCCESS.TITLE,
                description: '',
                type: NotificationTypes.SUCCESS,
            });
            const createdProductId = response.data.commodity.id
            if (createdProductId && uploadedImage) await uploadProductImage(createdProductId, uploadedImage, false, true)
            return createdProductId
        } catch (error) {
            console.error(error)
        } finally {
            setUpdateLoading(false);
        }
    };
    const getCommodity = async (commodityId: number) => {
        try {
            setLoading(true);
            const url = generatePath(ApiRoutes.GET_LIVE_STOCK_COMMODITY, { commodityId })
            const res = await axiosInstance.get(url);
            const desiredData = deserialize(LiveStockCommodityModel, res.data.commodity)
            setCommodity(desiredData);
            return desiredData
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);
        }
    };
    const updatedCommodity = async (payload: LiveStockCommodityModel, commodityId: number) => {
        try {
            setUpdateLoading(true);
            const uploadedImage = payload.image;
            const rcFile = await urlToRcFile(payload?.imageUrl ?? '', true);
            const desiredImage = payload.image?.uid == '-1' ? rcFile : uploadedImage; // Sending image file format to uploadProductImage API
            delete payload.image
            const desiredPayload = serialize(LiveStockCommodityModel, payload)
            const url = generatePath(ApiRoutes.GET_LIVE_STOCK_COMMODITY, { commodityId })
            const response = await axiosInstance.put(url, { commodity: desiredPayload })
            Notification({
                message: notificationConstants.SUCCESS.UPDATE_TITLE,
                description: '',
                type: NotificationTypes.SUCCESS,
            });
            const createdProductId = response.data.commodity.id
            if (createdProductId && desiredImage && uploadedImage?.uid !== '-1') await uploadProductImage(createdProductId, desiredImage, false, true)
            return true
        } catch (error) {
            console.error(error)
        } finally {
            setUpdateLoading(false);
        }
    };
    return {
        loading,
        updateLoading,
        createLiveStockCommodity,
        getCommodity,
        commodity,
        updatedCommodity
    }
}

export default LiveStockService